exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, " select {\r\n     /*Removes border*/\r\n     -webkit-appearance: none;\r\n     -moz-appearance: none;\r\n     appearance: none;\r\n     text-overflow: '';\r\n     text-indent: 0.01px;\r\n     /* Removes default arrow from firefox*/\r\n     text-overflow: \"\";\r\n     /* background: url(http://www.stackoverflow.com/favicon.ico) 98% / 13% no-repeat #fff; */\r\n     /*Removes default arrow from firefox*/\r\n }\r\n \r\n select::-ms-expand {\r\n     display: none;\r\n }\r\n \r\n .select-wrapper {\r\n     padding-left: 0px;\r\n     overflow: hidden;\r\n }\r\n \r\n span,\r\n a:hover {\r\n     cursor: pointer\r\n }\r\n \r\n .input-search-icon {\r\n     color: green;\r\n     \r\n     border-color: #ece9e9;\r\n     background-color: #f6f6f6;\r\n     border-left: none;\r\n     border-top-left-radius: 0 !important;\r\n     border-bottom-left-radius: 0 !important;\r\n     box-shadow: 0px 7px 7px #ddd !important;\r\n\r\n }\r\n ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dropdown/dropdown.css
// module id = 1101
// module chunks = 320